import styles from './SubHeader.module.scss';

const SubHeader = ({ title, breadcrumbs }) => {
  return (
    <div className={styles.header}>
      <div className={styles.headerSection}>
        <div className={styles.title}>
          <h1 className={styles.headerTitle}>{title}</h1>
        </div>
        <div className={styles.breadcrumbsWrap}>
          <div className={styles.breadcrumbs}>
            <ul>
              {breadcrumbs.map((crumb, index) => (
                <li key={index}>
                  {crumb.link ? (
                    <a href={crumb.link} className={styles.link}>
                      {crumb.label}
                    </a>
                  ) : (
                    <span className={styles.label}>{crumb.label}</span>
                  )}
                  {index < breadcrumbs.length - 1 && <span>/ </span>}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};


export default SubHeader;
